const ruleFields = ['msku_template', 'series', 'style', 'msku_separator',
    'supplier', 'country', 'msku_color'];

export function mskuRuleCandidates(rows) {
    return (rows || []).map(row => {
        const values = Object.assign({}, row.upload_overrides || {}, row.config_overrides || {}, row.draft_config || {});
        ruleFields.forEach(key => {
            if (row[key] !== undefined && row[key] !== null) values[key] = row[key];
        });
        const mode = row.mode || values.mode;
        if (mode === 'template' || mode === 'attribute') values.use_msku_template = mode === 'template';
        return { parent: row.parent, pm: row.pm, shop: row.shop, success: true, config_overrides: values };
    });
}

export async function confirmMskuRules(vm, rows, regenerationNotice = '') {
    const endpoint = '/vue/msku-generation/generate/multi/sync-upload-config';
    const response = await vm.$axios.post(endpoint, { rows: mskuRuleCandidates(rows), preview: true });
    if (response.code !== 200 || !response.data) throw new Error(response.message || 'MSKU规则读取失败');
    const changed = response.data.rows || [];
    if (!changed.length && !regenerationNotice) return true;
    const lines = changed.map(row => `${row.parent} / ${row.pm} / ${row.shop}：`
        + (row.changes || []).map(field => `${field.label}：${String(field.old) || '空'} → ${String(field.new) || '空'}`).join('；'));
    const message = [regenerationNotice, ...lines,
        changed.length ? '是否把这些 MSKU 规则保存为该品名以后的默认规则？选择“仅本次生成”仍使用当前输入。' : '是否继续重新生成？']
        .filter(Boolean).join('\n\n');
    try {
        await vm.$confirm(message, changed.length ? '保存 MSKU 生成规则' : '重新生成确认', {
            confirmButtonText: changed.length ? '保存规则并生成' : '重新生成',
            cancelButtonText: changed.length ? '仅本次生成' : '取消',
            distinguishCancelAndClose: true, closeOnClickModal: false, type: 'warning',
        });
    } catch (action) {
        return changed.length > 0 && action === 'cancel';
    }
    if (changed.length) {
        const saved = await vm.$axios.post(endpoint, { rows: changed });
        if (saved.code !== 200 || !saved.data) throw new Error(saved.message || 'MSKU规则保存失败');
        vm.$message.success(`已保存 ${saved.data.synced_count} 个品名的 MSKU 规则`);
    }
    return true;
}

export function configSaveSummary(items) {
    const groups = new Map();
    let total = 0;
    (items || []).forEach(item => {
        total += (item.mskus || []).length;
        (item.mskus || []).forEach(msku => {
            if (!(item.msku_config_updates || {})[msku]) return;
            const key = JSON.stringify([item.parent, item.pm, item.shop]);
            if (groups.has(key)) throw new Error(`品名「${item.pm}」有多个 MSKU 要求保存配置，请只选择一条代表行`);
            groups.set(key, `${item.parent} / ${item.pm} / ${item.shop}（来源 ${msku}）`);
        });
    });
    return `本次创建 ${total} 个 MSKU。\n\n`
        + (groups.size ? `以下 ${groups.size} 个品名将保存当前选中 MSKU 的配置，供以后使用：\n${[...groups.values()].join('\n')}\n\n其余 MSKU 的配置仅用于本次。`
            : '本次全部配置仅用于当前任务，不写入品名默认配置。');
}
